import React from "react";

interface IHtmlContent {
  text: string;
}

interface IProps {
  className?: string;
  content: IHtmlContent[];
}

const RenderHtml = ({ className, content }: IProps): JSX.Element | null => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `${content
          .map((node: { text: string }): string => node.text)
          .join("")}`,
      }}
    />
  );
};

export default RenderHtml;
